import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '../IconButton';

const propTypes = {

	/**
	 * The ID for the button element.
	 */
	id: PropTypes.string.isRequired,

	/**
	 * The URL of the external link for documentation.
	 */
	href: PropTypes.string.isRequired,

	/**
	 * The hover title text for the button element,
	 * used to describe the contents of the external link.
	 */
	title: PropTypes.string.isRequired,

	/**
	 * The size of the button element (including the hover background), default value is 24px.
	 */
	size: PropTypes.string,

};

const defaultProps = {
	size: '24px',
};

/**
 * Shared component to render a TechChange "Learn More" link button,
 * which can be used for redirection to external documentation.
 *
 * @param {Object} props The props.
 *
 * @returns {Object} The rendered component.
 */
const LearnMoreLink = (props) => {

	const {
		href,
		...restProps
	} = props;

	return (
		<IconButton
			{...restProps}
			className={`tc-learn-more-link ${restProps.className || ''}`}
			icon="fa-light fa-question-circle"
			tag={
				<a
					href={href}
					target="_blank"
					rel="noopener noreferrer nofollow">
					{' '}
				</a>
			}
			tooltip />
	);

};

LearnMoreLink.propTypes = propTypes;
LearnMoreLink.defaultProps = defaultProps;

export default LearnMoreLink;
